import axios, { AxiosResponse } from 'axios';
import { ErrorResponse } from 'services/api';

/**
 * Normalize varios types of request error into an instance of Error
 *
 * @param error unknown
 * @returns Error
 * @throws Error when error is not type of Error | AxiosError
 * @see https://www.intricatecloud.io/2020/03/how-to-handle-api-errors-in-your-web-app-using-axios/
 */
function handleApiError(error: unknown): Error {
  if (axios.isAxiosError(error)) {
    let message = 'Unknown error...';
    if (error.response) {
      // server responded with 400 and 500 range of error
      // const response = error.response.data as ErrorResponse;
      const axiosResponse = error.response as AxiosResponse<ErrorResponse>;
      const data = axiosResponse.data;
      message =
        data && 'data' in data
          ? data.data.message
          : 'Server error without response';
      // for geolocator error handling
      if (data && data.meta) {
        message = data.errors ? data.errors[0].detail : message;
      }
      const exception_type =
        data && 'data' in data ? data.data.exception_type : '';
      if (axiosResponse.status === 429)
        message = 'Too many requests. Please try again later.';
      const e = new Error(message);
      e.name = exception_type;
      return e;
    } else if (error.request) {
      // for some reason request has no respone
      // e.g.
      // - network error
      // - backend is hanging on each request and not returning a response on time
      // - making cross-domain requests with no authorization
      return new Error('Request error');
    } else {
      // anything else related to app
      return error;
    }
  } else {
    if (error instanceof Error) return error;
    throw new Error('Unexpected error');
  }
}

export default handleApiError;
